import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

export const isWhiteLabel = (state) => {
  return state.plan.group === 'white-label'
}

export const canRemoveHowCanWeHelpAfterOffer = (_, __, ___, rootGetters) => {
  return isFeatureEnabled(rootGetters, 'release-AHA-38641-remove-how-can-we-help-after-offer')
}
